import { render } from "./KryptonDeleteButton.vue?vue&type=template&id=3d8fbabc&lang=pug"
import script from "./KryptonDeleteButton.vue?vue&type=script&lang=js"
export * from "./KryptonDeleteButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__